import CeisaClientLoginIndex from "@/components/exim/ceisa/client_login/CeisaClientLoginIndex.vue";
import CeisaClientLoginDetail from "@/components/exim/ceisa/client_login/CeisaClientLoginDetail.vue";
import CeisaClientLoginEdit from "@/components/exim/ceisa/client_login/CeisaClientLoginEdit.vue";
import CeisaClientLoginCreate from "@/components/exim/ceisa/client_login/CeisaClientLoginCreate.vue";

let CeisaClientLoginRoute= [
    {
        path: '',
        meta: {
          title: "Ceisa Client Login",
        },
        name: "CeisaClientLoginIndex",
        component: CeisaClientLoginIndex
    },

    {
      path: 'detail/:id',
      meta: {
        title: "Ceisa System Code Detail",
      },
      name: "CeisaClientLoginDetail",
      component: CeisaClientLoginDetail
    },

    {
      path: 'edit/:id',
      meta: {
        title: "Ceisa System Code Update",
      },
      name: "CeisaClientLoginEdit",
      component: CeisaClientLoginEdit
    },

    {
      path: 'create',
      meta: {
        title: "Ceisa System Code Create",
      },
      name: "CeisaClientLoginCreate",
      component: CeisaClientLoginCreate
    }
    
]

export default CeisaClientLoginRoute
  